export default __webpack_public_path__ + "static/renishaw_logo.inline-f2b441565eab6078ceee40e5d94a9ddd.png";